import { ACTION_TYPES, useDocumentosSetoriaisDispatch, useDocumentosSetoriaisState } from "./documentos-setoriais-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IDocumentoSetorialPagedRequest } from "models/request/documento-setorial-paged-request";
import { downloadFile } from "utils/download-file";
import { slugify } from "utils/slugify";

export const useDocumentosSetoriaisController = () => {
    const dispatch = useDocumentosSetoriaisDispatch();
    const { documentoSetorialPagedRequest } = useDocumentosSetoriaisState();

    async function exportDocumentosSetoriais(format: string) {
        const file = await MunicipalPortalAAppService.exportDocumentosSetoriais(documentoSetorialPagedRequest, format);
        downloadFile(file);
    }

    async function onInit(initialAreaSlug?: string) {
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });

        const areas = await loadLookups();

        const areaSelecionada = initialAreaSlug
            ? areas?.find((a) => slugify(a.name).includes(initialAreaSlug) || initialAreaSlug.includes(slugify(a.name)))
            : undefined;

        let request = { page: 0, pageSize: 10, idAreaTransparenciaSetorial: areaSelecionada?.id } as IDocumentoSetorialPagedRequest;

        dispatch({ type: ACTION_TYPES.setDocumentoSetorialPagedRequest, payload: request });

        await listDocumentosSetoriais(request);

        dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function loadLookups() {
        try {
            const [tipos, areas, ultimaAtualizacao] = await Promise.all([
                MunicipalPortalAAppService.listTiposDocumentoSetorial(),
                MunicipalPortalAAppService.listAreasTransparenciaSetorial(),
                MunicipalPortalAAppService.getDocumentosSetoriaisUltimaAtualizacao()
            ]);
            dispatch({ type: ACTION_TYPES.setTipos, payload: tipos });
            dispatch({ type: ACTION_TYPES.setAreas, payload: areas });
            dispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
            return areas;
        } catch (error) {
            console.log(error);
            return undefined;
        }
    }

    async function listDocumentosSetoriais(request: IDocumentoSetorialPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            dispatch({ type: ACTION_TYPES.setError, payload: null });

            const [documentos, totais] = await Promise.all([
                MunicipalPortalAAppService.listDocumentosSetoriais(request),
                MunicipalPortalAAppService.getDocumentosSetoriaisTotais({
                    term: request.term,
                    idTipoDocumentoSetorial: request.idTipoDocumentoSetorial,
                    idAreaTransparenciaSetorial: request.idAreaTransparenciaSetorial,
                    ano: request.ano,
                }),
            ]);

            dispatch({ type: ACTION_TYPES.setDocumentos, payload: documentos });
            dispatch({ type: ACTION_TYPES.setTotais, payload: totais });
        } catch (error) {
            console.log(error);
            dispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar os documentos setoriais. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...documentoSetorialPagedRequest };

        if (e.target.name === "text-field-term") {
            updated.term = e.target.value;
            if (!updated.term) {
                (async () => await listDocumentosSetoriais({ ...updated, page: 0 }, true))();
            }
        } else if (e.target.name === "select-tipo-id") {
            updated.idTipoDocumentoSetorial = e.target.value;
        } else if (e.target.name === "select-area-id") {
            updated.idAreaTransparenciaSetorial = e.target.value;
        } else if (e.target.name === "text-field-ano") {
            updated.ano = e.target.value ? Number(e.target.value) : undefined;
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listDocumentosSetoriais({ ...updated, page: 0 }, true))();
        }

        dispatch({ type: ACTION_TYPES.setDocumentoSetorialPagedRequest, payload: updated });
    };

    return { listDocumentosSetoriais, handleOnChange, onInit, exportDocumentosSetoriais };
}
